import { useEffect, useState } from "react";

export const LOCALE = "en-CA";

function getLocalStorageIntValue(key: string, defaultValue: number): number {
  // getting stored value
  const saved = localStorage.getItem(key);
  const initial = saved ? parseInt(saved) : defaultValue;
  return initial || defaultValue;
}

export const useLocalIntStorage = (key: string, defaultValue: number) => {
  const [value, setValueStr] = useState(() => {
    return getLocalStorageIntValue(key, defaultValue).toString();
  });

  useEffect(() => {
    // storing input name
    localStorage.setItem(key, value.toString());
  }, [key, value]);

  function setValue(n: number) {
    setValueStr(n.toString());
  }

  return [parseInt(value), setValue];
};

function getLocalStorageValue(key: string, defaultValue: string) {
  // getting stored value
  const saved = localStorage.getItem(key);
  const initial = saved ? JSON.parse(saved) : defaultValue;
  return initial || defaultValue;
}

export const useLocalStorage = (key: string, defaultValue: string) => {
  const [value, setValue] = useState(() => {
    return getLocalStorageValue(key, defaultValue);
  });

  useEffect(() => {
    // storing input name
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};

export enum SessionFilterKeys {
  Query = "queryFilter",
  User = "userFilter",
  Study = "studyFilter",
  Image = "imageFilters",
  Case = "caseFilters",
  ImageManagementSearch = "imageManagementSearch",
  ImageManagementCaseSearch = "imageManagementCaseSearch",
  ImageManagementAnnotationSearch = "imageManagementAnnotationSearch",
  EditStudyUsers = "editStudyUsers"
}

export const saveFiltersToSession = <T>(key: string, filters: T): void => {
  // eslint-disable-next-line  functional/no-try-statement
  try {
    sessionStorage.setItem(key, JSON.stringify(filters));
  } catch {
    //console.warn("Could not save filters to sessionStorage:", e);
  }
};

export const loadFiltersFromSession = <T>(key: string): T | undefined => {
  // eslint-disable-next-line  functional/no-try-statement
  try {
    const saved = sessionStorage.getItem(key);
    //console.log(`loadFiltersFromSession key=${key} saved=${saved}`);
    return saved ? (JSON.parse(saved) as T) : undefined;
  } catch (e) {
    //console.warn(`Could get saved filters from sessionStorage for key ${key}, error=${e}`);
    return undefined;
  }
};
